/** The value format of `input[type="date"]`. */
export const DATE_INPUT_FORMAT = 'YYYY-MM-DD';

/** The value format of `input[type="time"]`. */
export const TIME_INPUT_FORMAT = 'HH:mm';
